import { render, staticRenderFns } from "./AddApproveModal.vue?vue&type=template&id=821fcfe4&scoped=true&"
import script from "./AddApproveModal.vue?vue&type=script&lang=ts&"
export * from "./AddApproveModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddApproveModal.vue?vue&type=style&index=0&id=821fcfe4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821fcfe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
